import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a diet?',
    a: "It's a 7-day nutritional protocol focused on inflammation, not calorie counting."
  }, {
    q: 'Do I need special tools?',
    a: 'No. Your hands are the only tools required for the manual sculpt.'
  }, {
    q: 'How soon will I see results?',
    a: 'Most women notice a significant difference in eye puffiness by Day 2 and jawline definition by Day 4.'
  }, {
    q: 'Can I do this while working?',
    a: 'Yes. The routines take less than 10 minutes a day total.'
  }];
  return <Section bg="cream" data-id="element-31">
      <div className="max-w-3xl mx-auto" data-id="element-32">
        <h2 className="text-4xl font-serif text-center mb-12" data-id="element-33">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-35" />)}
        </div>
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-sage/10" data-id="element-36">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-37">
        <span className="font-semibold text-lg pr-8" data-id="element-38">{question}</span>
        <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-39" />
      </button>
      <AnimatePresence data-id="element-40">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-41">
            <div className="px-6 pb-5 text-charcoal/70 leading-relaxed border-t border-sage/5 pt-3" data-id="element-42">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}